import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  cardContainer: {
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px',
    padding: '16px',
    margin: '16px 5px',
    background: '#fff',
    minWidth: '200px',
    '@media(min-width: 800px)': {
      padding: '12px',
      margin: '16px 16px 16px 5px',
      width: '216px',
      height: '108px'
    }
  },
  flexView: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    alignSelf: 'center'
  },
  bodyText: {
    ...theme.typography.labelTiny,
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '17px',
    marginLeft: '16px',
    color: '#000000'
  },
  chipView: {
    background: '#14D15B',
    borderRadius: '30px',
    padding: '4px 10px',
    fontFamily: 'SF UI Display, sans-serif',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: 'clamp(0.7em, 0.7vw, 0.9em)',
    color: '#fff',
    marginRight: '6px',
    '@media(min-width: 800px)': {
      fontSize: '6px',
      alignSelf: 'center',
      padding: '4px 9px'
    }
  },
  starCircle: {
    background: '#FFD051',
    borderRadius: '24px',
    padding: '2px',
    height: '20px',
    display: 'flex',
    width: '20px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)'
  },
  thumbCircle: {
    background: '#FFD051',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
    borderRadius: '100px',
    padding: '2px',
    height: '20px',
    width: '20px'
  },
  groupView: {
    margin: '27px 0px 41px 0px',
    textAlign: 'center',
    '@media(min-width: 800px)': {
      margin: '25px 0px 14px 0px'
    }
  }
}));
